import React from 'react'

const CryptocurrencyIcon = () => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M60.6491 64.13H3.37906C2.36906 64.13 1.53906 63.39 1.53906 62.48V16.65C1.53906 15.74 2.35906 15 3.37906 15H76.7891C77.7991 15 78.6291 15.74 78.6291 16.65V62.48C78.6291 63.39 77.8091 64.13 76.7891 64.13H60.6491V64.13Z"
      stroke="#CCCCCC"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M34.5 64.2598V68.7098"
      stroke="#CCCCCC"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M43.0508 64.3301V68.7101"
      stroke="#CCCCCC"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M56.8798 68.6895H19.8398"
      stroke="#CCCCCC"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M58.7501 60.6709H6.75008C5.83008 60.6709 5.08008 60.0309 5.08008 59.2509V19.8809C5.08008 19.1009 5.83008 18.4609 6.75008 18.4609H73.4101C74.3301 18.4609 75.0801 19.0909 75.0801 19.8809V59.2509C75.0801 60.0309 74.3301 60.6709 73.4101 60.6709H58.7501Z"
      stroke="#CCCCCC"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M25.0002 30.7302L28.0002 32.4302M30.7002 24.7102L32.5402 27.3102M53.6002 30.3302L50.7102 32.2102M47.2902 24.2102L45.6102 27.1302M50.5702 45.2302L53.8302 46.9402M32.6102 49.7202L30.5802 52.9002M28.0002 44.7902L24.8502 46.7002M26.4602 38.6002H22.9102M55.9202 37.9802H52.3702M45.7102 50.0202L47.8602 53.1502M39.4102 51.6702V55.5002M39.4102 22.2002V25.5402M40.4302 47.5902V43.5602M38.4002 47.5902V43.5602M40.5902 33.7402V29.7102M38.5602 33.7402V29.7102M34.1002 43.5202H41.5602C42.7002 43.5202 44.7202 43.1602 44.7202 40.8202C44.7202 38.4802 42.1802 37.9802 42.1802 37.9802M34.1002 33.7502H40.5602C41.9702 33.7502 43.8502 33.7802 43.8502 35.8702C43.8502 37.9602 42.1802 37.9902 42.1802 37.9902H36.8902M36.8202 33.7602V43.5402M63.6202 51.5202V58.2702M15.0702 52.7902V59.5402M55.1502 19.6602V26.3402M22.9102 50.2002V56.9502M70.0502 25.7502V34.0502M58.6902 41.1202V47.6902M11.0302 37.8502V45.9602M19.9802 21.6802V30.1102M52.3602 38.6002C52.3602 45.8202 46.5602 51.6602 39.4102 51.6602C32.2602 51.6602 26.4602 45.8102 26.4602 38.6002C26.4602 31.3902 32.2602 25.5402 39.4102 25.5402C46.5602 25.5402 52.3602 31.3902 52.3602 38.6002ZM55.9102 38.8402C55.9102 48.0402 48.5202 55.4902 39.4102 55.4902C30.3002 55.4902 22.9102 48.0402 22.9102 38.8402C22.9102 29.6402 30.3002 22.1902 39.4102 22.1902C48.5202 22.1902 55.9102 29.6402 55.9102 38.8402ZM70.0502 44.1402C70.0502 45.2802 69.1402 46.2002 68.0102 46.2002C66.8802 46.2002 65.9702 45.2802 65.9702 44.1402C65.9702 43.0002 66.8802 42.0802 68.0102 42.0802C69.1402 42.0802 70.0502 43.0002 70.0502 44.1402ZM62.3802 31.2302C62.3802 32.3702 61.4702 33.2902 60.3402 33.2902C59.2102 33.2902 58.3002 32.3702 58.3002 31.2302C58.3002 30.0902 59.2102 29.1702 60.3402 29.1702C61.4702 29.1702 62.3802 30.0902 62.3802 31.2302ZM13.0702 30.9602C13.0702 32.1002 12.1602 33.0202 11.0302 33.0202C9.90023 33.0202 8.99023 32.1002 8.99023 30.9602C8.99023 29.8202 9.90023 28.9002 11.0302 28.9002C12.1602 28.9002 13.0702 29.8202 13.0702 30.9602ZM20.5302 42.1002C20.5302 43.2402 19.6202 44.1602 18.4902 44.1602C17.3602 44.1602 16.4502 43.2402 16.4502 42.1002C16.4502 40.9602 17.3602 40.0402 18.4902 40.0402C19.6202 40.0402 20.5302 40.9602 20.5302 42.1002Z"
      stroke="#009CDE"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
  </svg>
)

export default CryptocurrencyIcon
